import { Transfer } from '../../lib/types/models/transfer/transfer'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTransfer(id: number) {
  return restApiClient.url(constructApiUrl(API.transfer.get.url, { id })).get<Transfer>()
}
